import MobileMenu from './components/MobileMenu'
import CopyToClipboard from './components/CopyToClipboard'
import PaymentPage from './components/PaymentPage'
import AcceptTOS from './components/AcceptTOS'

import css from '../sass/app.sass'

window.onload = () => {

  // Matomo tracking code
  (function () {
    // Don't insert marketing tracking script on payment page
    // See https://matomo.org/faq/how-to/faq_89/
    if (String(window.location.pathname).endsWith('/payment/')) return

    var u = process.env.MATOMO_ROOT
    _paq.push(['setTrackerUrl', u + 'matomo.php'])
    _paq.push(['setSiteId', process.env.MATOMO_SITE_ID])
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0]
    g.type = 'text/javascript'
    g.async = true
    g.src = u + 'matomo.js'
    s.parentNode.insertBefore(g, s)
  })()

  const mobileMenu = new MobileMenu()
  const acceptTOS = new AcceptTOS()

  // Automatically copy to clipboard the pgp key on click
  const pgpKey = document.getElementById('pgp--key')
  if (pgpKey) {
    const copyResponse = document.getElementById('pgp--result-copy')
    const copyToClipboard = new CopyToClipboard(pgpKey, copyResponse)
  }

  if (String(window.location.pathname).endsWith('/payment/')) {
    const paymentPage = new PaymentPage().mount().then((ref) => {
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
        window.paymentPage = ref
      }
    })
  }

  document.documentElement.className = 'has-navbar-fixed-top'
}
